import { Button, CircularProgress } from "@material-ui/core";
import React from "react";
import styled from "styled-components";
import { Spacing } from "../../config";
import { formConnector } from "../../FormConfig";
import FontStyle from "../styles/fontsStyles";

const StyledButton = styled(Button)(({ theme, $alternative }) => {
  const { palette: colors, spacing } = theme;
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: spacing(0.7, 2),
    flexShrink: 0,
    overflow: "hidden",
    backgroundColor: colors.secondary.main,
    color: $alternative
      ? colors.background.associated
      : colors.secondary.contrastText,
    borderColor: $alternative
      ? colors.background.associated
      : colors.secondary.contrastText,
    borderWidth: spacing(0.125),
    ...FontStyle.semibold14,
    textTransform: "uppercase",
    ".MuiButton-startIcon": {
      fill: colors.secondary.contrastText,
      width: 17,
    },
  };
});

const StyledCircularProgress = styled(CircularProgress)(({ theme, $show }) => {
  const { palette: colors } = theme;
  return {
    position: "absolute",
    color: colors.secondary.main,
    transition: ".5s",
    opacity: $show ? 1 : 0,
  };
});

const ChildrenContainer = styled.div(({ $show }) => {
  return {
    transition: ".5s",
    opacity: $show ? 1 : 0.5,
  };
});

function ButtonTextComponent({
  fullWidth = true,
  loading,
  children,
  type,
  disabled,
  name,
  alternative,
  ...props
}) {
  const {
    disabled: stateDisabled,
    onClick,
    ref,
  } = formConnector.useFormButton({
    type,
    disabled,
    name,
  });
  return (
    <StyledButton
      $alternative={alternative}
      variant="outlined"
      ref={ref}
      type={null}
      fullWidth={fullWidth}
      disabled={stateDisabled}
      onClick={onClick}
      {...props}
    >
      <StyledCircularProgress size={Spacing(3)} $show={loading} />
      <ChildrenContainer $show={!loading}>{children}</ChildrenContainer>
    </StyledButton>
  );
}

export default ButtonTextComponent;
